import React, { useState } from "react"; 
import axios from "axios";
import { baseurl } from "../Baseurl";
import Swal from 'sweetalert2';
import { Eye, EyeOff } from "react-feather";
import VisitorNavbar from "../component/VisitorNavbar";
import VisitorSidebar from "../component/VisitorSidebar";

const ChangePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const cust_id = localStorage.getItem("cust_id");

  const validatePassword = (pwd) => {
    const regex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(pwd);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      Swal.fire("Error", "Both fields are required", "error");
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire("Error", "Passwords do not match", "error");
      return;
    }

    if (!validatePassword(password)) {
      Swal.fire(
        "Weak Password",
        "Password must be at least 8 characters long, include one uppercase letter, one number, and one special character.",
        "warning"
      );
      return;
    }

    const requestData = {
      cust_id: cust_id,
      password: password,
    };

    try {
      const response = await axios.post(`${baseurl}updateCustomerPassword`, requestData);

      if (response.data.message === "Password updated successfully.") {
        Swal.fire("Success", "Password updated successfully", "success");
        setPassword("");
        setConfirmPassword("");
      }
    } catch (error) {
      console.error("Error updating password:", error);
      Swal.fire("Error", "Failed to update password. Please try again later.", "error");
    }
  };

  return (
    <>
      <VisitorNavbar/>
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <VisitorSidebar/>
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1">Change Password</h4>
                  <p className="payttl">Update your account password.</p>
                  <hr />
                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6 position-relative">
                        <label htmlFor="password" className="form-label">
                          New Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                          <span
                            className="input-group-text"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                          </span>
                        </div>
                      </div>

                      <div className="col-md-6 position-relative">
                        <label htmlFor="confirmPassword" className="form-label">
                          Confirm Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type={showConfirm ? "text" : "password"}
                            className="form-control"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                          />
                          <span
                            className="input-group-text"
                            onClick={() => setShowConfirm(!showConfirm)}
                            style={{ cursor: "pointer" }}
                          >
                            {showConfirm ? <EyeOff size={16} /> : <Eye size={16} />}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 text-end">
                      <button type="submit" className="btn submitbtnn w-25">
                        Update Password
                      </button>
                    </div>

                    <div className="mt-3">
                      <p className="text-muted small">
                        Password must be at least 8 characters, include 1 uppercase letter, 1 number, and 1 special character.
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ChangePassword;
